import { UserBasic } from '@hefe/models';
import { Flex, Typography } from 'antd';
import UserAvatar from '../../../core/components/user/user-avatar/user-avatar/user-avatar.component';

interface IssueUserBlockComponentProps {
  user: UserBasic;
}

export default function IssueUserBlockComponent(
  props: IssueUserBlockComponentProps
) {
  const { user } = props;

  return (
    <Flex gap={10} align="center">
      <UserAvatar user={user} size={40} />
      <div>
        <Typography.Text strong>
          {user.firstname} {user.lastname}
        </Typography.Text>

        {/* Subtitle
  <Typography.Text
          type="secondary"
          style={{ display: 'block', fontSize: 12 }}
        >
          Widersprüchliche Aufgaben
        </Typography.Text>
  */}
      </div>
    </Flex>
  );
}
